import { TabMode } from "src/types"

export const NEW_TAB_DEFAULTS: Readonly<{
  mode: TabMode
}> = Object.freeze({
  mode: "text",
})
